import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateKeyValueRequest } from '@models/base/createKeyValueRequest.model';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdateKeyValueRequest } from '@models/base/updateKeyValueRequest.model';
import { CreateCuentaCajaRequest } from '@models/cuentaCaja/createCuentaCajaRequest.model';
import { CuentaCajaDto } from '@models/cuentaCaja/cuentaCajaDto.model';
import { UpdateCuentaCajaRequest } from '@models/cuentaCaja/updateCuentaCajaRequest.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class CuentaCajaService {
  constructor(private http:HttpClient) {
  }

  create(createCuentaCajaRequest:CreateCuentaCajaRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/CuentaCaja/Create",createCuentaCajaRequest);
  }

  update(updateCuentaCajaRequest:UpdateCuentaCajaRequest):Observable<any>
  {
    return  this.http.put<any>("/api/CuentaCaja/Update",updateCuentaCajaRequest);
  }

  getAll():Observable<CuentaCajaDto[]> {
    return   this.http.get<CuentaCajaDto[]>("/api/CuentaCaja/GetAll");
  }

  getById(id:number):Observable<CuentaCajaDto>{
    return  this.http.get<CuentaCajaDto>("/api/CuentaCaja/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/CuentaCaja/Delete?id=" + id);
    else
      return of(null)
  }
}
